import type { NotifyPort } from '@/features/messages/domain/notify'
import type { MemberFilter, MemberPort, TeamMember } from '../domain/member'

const listMembers = async (port: MemberPort, filter: MemberFilter, notify: NotifyPort): Promise<TeamMember[]> => {
	try {
		return await port.list(filter)
	} catch (err) {
		if ((err as { isAbort?: boolean })?.isAbort) return []
		notify.error('hr.membersLoadFailed')
		return []
	}
}

export { listMembers }
